import { BaseRecord } from 'app/context/data/types';
import { Descriptions } from 'app/modules/ui';
import React from 'react';
import type { ShippingInformation as IShippingInformation } from 'app/definitions/interfaces/Product';
import { DESCRIPTION_SHIPPING_INFORMATION } from './config';
import classes from './ShippingInformationItem.module.scss';

type ShippingInformationProps<T = BaseRecord> = {
  type: 'sellingUnitContent' | 'innerPackContent' | 'outerCartonContent';
  value: T;
  // descriptionDef: any[];
  shippingInformation: IShippingInformation;
};

const TITLE_WITH_TYPE = {
  sellingUnitContent: 'Selling Unit',
  innerPackContent: 'Inner Pack',
  outerCartonContent: 'Outer Carton'
};

export const ShippingInformation = (props: ShippingInformationProps) => {
  const { type, value, shippingInformation } = props;

  return (
    <Descriptions
      className={classes.item}
      title={TITLE_WITH_TYPE[type]}
      items={DESCRIPTION_SHIPPING_INFORMATION}
      value={value}
      meta={{ shippingInformation: shippingInformation || {} }}
    />
  );
};
